/* eslint-disable react/prop-types */

'use strict';

const { h } = require('preact');

const UrgencyPriceLabel = ({
  option: {
    isUrgencyPricing,
    pricing: { urgencyPricing },
    showDoubleStrikeThroughPrice,
  },
}) => {
  if (!isUrgencyPricing) {
    return null;
  }
  let classes = 'urgency-pricing-label urgency-pricing c-txt-err';

  if (showDoubleStrikeThroughPrice) {
    classes += ' double-strike-label';
  }

  return h(
    'div',
    {
      class: classes,
    },
    urgencyPricing.offerLabel
  );
};

module.exports = UrgencyPriceLabel;
